/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface TravelControllerDeleteAttachment$Params {
  id: number;
  media_id: number;
}

export function travelControllerDeleteAttachment(http: HttpClient, rootUrl: string, params: TravelControllerDeleteAttachment$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, travelControllerDeleteAttachment.PATH, 'delete');
  if (params) {
    rb.path('id', params.id, {});
    rb.path('media_id', params.media_id, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

travelControllerDeleteAttachment.PATH = '/travel/{id}/attachment/{media_id}';
